import angular from 'angular'
import moment from 'moment-timezone'
import Quill from 'quill'
import 'quill/dist/quill.snow.css'
angular.module('admin.post.edit', []).controller('PostsAdminEditCtrl', PostsAdminEditCtrl)

/** @ngInject */
function PostsAdminEditCtrl(
  $scope,
  $state,
  $sce,
  $rootScope,
  $stateParams,
  $timeout,
  PostsAdminService,
  CacheService,
  TagsService,
  UploadService,
  CsvService,
  ChannelGroupChildrenService,
) {
  var vm = this
  vm.model = {
    'img-h': '',
  }
  vm.pathImgH = ''
  vm.params = $stateParams.id
  vm.isOpen = false
  vm.isOpen2 = false

  vm.segmentations = []
  vm.productSegmentations = []
  vm.channels = []
  vm.range = null

  vm.tags = []
  vm.model.tags = []
  vm.tagsList = []

  
  const toolbarOptions = {
    container: [
      ['bold', 'italic', 'underline', 'strike'], // toggled buttons
      ['blockquote', 'code-block'],

      [{ list: 'ordered' }, { list: 'bullet' }],

      // [{ script: 'sub' }, { script: 'super' }], // superscript/subscript

      // [{ indent: '-1' }, { indent: '+1' }], // outdent/indent

      // [{ color: [] }, { background: [] }], // dropdown with defaults from theme
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      ['clean'], // remove formatting button

      ['link', 'image'], // link and image
    ],
    handlers: {
      image: function () {
        vm.range = this.quill.getSelection()
        $('#modalImagePost').modal('show')
      },  
      // video: function () {
      //   vm.range = this.quill.getSelection()
      //   $('#modalVideoPost').modal('show')
      // },
    },
  }

  const options = {
    modules: {
      toolbar: toolbarOptions,
    },
    placeholder: 'Write something...',
    theme: 'snow',
  }
  const editor = new Quill('.editor', options)

  PostsAdminService.listSegmentation().then(function (result) {
    vm.segmentations = _.filter(result.results, { arch: false })
  })

  ChannelGroupChildrenService.listChannel().then(function (result) {
    vm.channels = result.results
  })

  vm.openCalendar = function (e) {
    e.preventDefault()
    e.stopPropagation()

    vm.isOpen = true
  }

  vm.openCalendar2 = function (e) {
    e.preventDefault()
    e.stopPropagation()

    vm.isOpen2 = true
  }

  vm.convertTimezone = function () {
    if (vm.data1) {
      vm.timezoneDatePublishedNY = moment(vm.data1)
        .tz('America/New_York')
        .format('MM/DD/YYYY HH:mm A')
      vm.timezoneDatePublishedLA = moment(vm.data1)
        .tz('America/Los_Angeles')
        .format('MM/DD/YYYY HH:mm A')
    }
    if (vm.data2) {
      vm.timezoneDateExpiredNY = moment(vm.data2)
        .tz('America/New_York')
        .format('MM/DD/YYYY HH:mm A')
      vm.timezoneDateExpiredLA = moment(vm.data2)
        .tz('America/Los_Angeles')
        .format('MM/DD/YYYY HH:mm A')
    }
  }

  if (vm.params !== '0') {
    vm.id = $stateParams.id
    PostsAdminService.get($stateParams.id).then(function (result) {
      vm.model = result.results

      if (vm.model.tags) {
        for (var i = 0; i < vm.model.tags.length; i++) {
          vm.tags.push(vm.model.tags[i].id)
        }
      } else {
        vm.model.tags = []
      }

      $('#e7').select2('data', vm.model.tags)

      if (vm.model['ts-p'] !== undefined && vm.model['ts-p'] !== 0) {
        vm.model['ts-p'] = vm.model['ts-p']
          .toString()
          .substring(0, vm.model['ts-p'].toString().length - 3)
        vm.model['ts-p'] = new Date(parseInt(vm.model['ts-p']))
        vm.data1 = angular.copy(vm.model['ts-p'])
        vm.timezoneDatePublishedNY = moment(vm.model['ts-p'])
          .tz('America/New_York')
          .format('MM/DD/YYYY HH:mm A')
        vm.timezoneDatePublishedLA = moment(vm.model['ts-p'])
          .tz('America/Los_Angeles')
          .format('MM/DD/YYYY HH:mm A')
      }
      if (vm.model['ts-x-pin'] !== undefined && vm.model['ts-x-pin'] !== 0) {
        vm.model['ts-x-pin'] = vm.model['ts-x-pin']
          .toString()
          .substring(0, vm.model['ts-x-pin'].toString().length - 3)
        vm.model['ts-x-pin'] = new Date(parseInt(vm.model['ts-x-pin']))
        vm.data2 = angular.copy(vm.model['ts-x-pin'])
        vm.timezoneDateExpiredNY = moment(vm.model['ts-x-pin'])
          .tz('America/New_York')
          .format('MM/DD/YYYY HH:mm A')
        vm.timezoneDateExpiredLA = moment(vm.model['ts-x-pin'])
          .tz('America/Los_Angeles')
          .format('MM/DD/YYYY HH:mm A')
      }

      if (vm.model['img-h'].indexOf('mp4') !== -1 || vm.model['img-h'].indexOf('mov') !== -1) {
        vm.model.isVideo = true
        vm.model.video = $sce.trustAsResourceUrl($rootScope.urlS3 + '/posts/' + vm.model['img-h'])
      } else {
        vm.model.isVideo = false
      }

      const content = JSON.parse(vm.model['txt-json'])
      editor.setContents(content)
    })

    PostsAdminService.listPostSegmentation($stateParams.id).then(function (result) {
      vm.postSegmentations = generateType(result.results)
    })
  }

  var isDate = function (date) {
    return new Date(date) !== 'Invalid Date' && !isNaN(new Date(date))
  }

  vm.modal = function () {
    $('#modalTags').modal('show')
  }

  $rootScope.$on('tagsList', function (event, data) {
    if (vm.tagsList) {
      data.map(function (item) {
        vm.tagsList.push(item)
      })
      vm.tagsList = _.uniqBy(vm.tagsList, 'id')
    } else {
      vm.tagsList = data
    }
  })

  vm.saveTags = function () {
    var split = vm.upTags.split(',')
    var tags = []

    for (var i = 0; i < split.length; i++) {
      tags.push({ name: split[i].trim() })
    }
    for (var x = 0; x < vm.model.tags.length; x++) {
      tags.push({ name: vm.model.tags[x].name })
    }
    TagsService.addTagPost($stateParams.id, tags).then(function () {
      toastr.success('Saved')
      $('#modalTags').modal('hide')
      $state.reload()
    })
  }

  vm.save = function () {
    var model = angular.copy(vm.model)
    delete model.ts
    var msg = ''

    model.txt = editor.root.innerHTML
    model['txt-json'] = JSON.stringify(editor.getContents())

    if (model.t === undefined || vm.data1 === undefined) {
      swal('Required title and published at fields.', '', 'error')
      return
    }

    if (model['txt-json']) {
      model['k-txt'] = 1
    }

    if (vm.data1 !== undefined && vm.data1 !== '' && vm.data1 !== null) {
      if (isDate(vm.data1)) {
        var date = parseInt(new Date(new Date(vm.data1).setSeconds(0)).getTime() * 1000)
        model['ts-p'] = date
        if (new Date(vm.data1) < new Date()) {
          model['ts-up'] = null
          msg = 'Post Saved and Published'
        } else {
          msg = 'Post Saved to Drafts as Pending'
        }
      } else {
        swal('Date field invalid.', '', 'error')
        return
      }
    } else {
      model['ts-p'] = null
      msg = 'Post Saved to Drafts'
    }

    if (vm.data2 !== undefined && vm.data2 !== '' && vm.data2 !== null) {
      if (isDate(vm.data2)) {
        var date = parseInt(new Date(new Date(vm.data2).setSeconds(0)).getTime() * 1000)
        model['ts-x-pin'] = date
      } else {
        swal('Date field invalid.', '', 'error')
        return
      }
    }

    if (model.pin === false) {
      model.pin = null
    }

    delete model.ts
    delete model['ts-m']

    var listTags = $('#e7').select2('val')
    var modelTags = []
    if (listTags !== undefined) {
      if (vm.model.tags !== undefined) {
        for (var i = 0; i < vm.model.tags.length; i++) {
          for (var j = 0; j < listTags.length; j++) {
            if (parseInt(listTags[j]) === vm.model.tags[i].id) {
              modelTags.push(vm.model.tags[i])
            }
          }
        }
      }

      for (var i = 0; i < vm.tagsList.length; i++) {
        for (var j = 0; j < listTags.length; j++) {
          if (parseInt(listTags[j]) === vm.tagsList[i].id) {
            modelTags.push(vm.tagsList[i])
          }
        }
      }
    }

    if (model.id !== undefined && model.id !== '' && model.id !== 0) {
      PostsAdminService.update(model.id, model).then(function (result) {
        TagsService.addTagPost(result.results.id, modelTags).then(function () {
          $('#alertResult').show()
          $('#resultMsg').text(msg)
          if ($stateParams.returnUrl) {
            window.location = $stateParams.returnUrl
          } else {
            $state.go('admin.posts')
          }
        })
      })
    } else {
      PostsAdminService.save(model).then(function (result) {
        TagsService.addTagPost(result.results.id, modelTags).then(function () {
          $('#alertResult').show()
          $('#resultMsg').text(msg)
          if ($stateParams.returnUrl) {
            window.location = $stateParams.returnUrl
          } else {
            $state.go('admin.posts')
          }
        })
      })
    }
  }

  vm.cancel = function () {
    swal(
      {
        title: 'Cancel News',
        text: 'You really want to cancel ?',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function (isConfirm) {
        if (isConfirm) {
          if ($stateParams.returnUrl) {
            window.location = $stateParams.returnUrl
          } else {
            $state.go('admin.posts')
          }
        }
      },
    )
  }

  vm.uploadH = function (item) {
    vm.loadH = true
    var id = 0
    if (item.id === undefined) {
      id = Math.floor(Math.random() * 100000000000000)
    } else {
      id = item.id
    }
    UploadService.save('posts', vm.pathImgH, 'img-h', id).then(function (fileName) {
      vm.loadH = false
      item['img-h'] = fileName
      if (item['img-h'].indexOf('mp4') !== -1 || item['img-h'].indexOf('mov') !== -1) {
        vm.model.isVideo = true
        vm.model.video = $sce.trustAsResourceUrl($rootScope.urlS3 + '/posts/' + vm.model['img-h'])
      } else {
        vm.model.isVideo = false
      }
    })
  }

  vm.uploadImage = function () {
    vm.loadImage = true
    // ramdom id
    const newId = Math.floor(Math.random() * 1000000000000000000)
    UploadService.save('posts', vm.pathImg, 'img-post', newId).then(function (fileName) {
      vm.loadImage = false
      vm.image = fileName
      const url = `${$rootScope.urlS3}/posts/${vm.image}`
      editor.insertEmbed(vm.range.index, 'image', url, Quill.sources.USER)
      $('#modalImagePost').modal('hide')

      $timeout(function () {
        vm.image = ''
      }, 1000)
    })
  }

  vm.uploadVideo = function () {
    vm.loadVideo = true
    // ramdom id
    const newId = Math.floor(Math.random() * 1000000000000000000)
    UploadService.save('posts', vm.pathVideo, 'video-post', newId).then(function (fileName) {
      vm.loadVideo = false
      vm.video = `${$rootScope.urlS3}/posts/${fileName}`
      editor.insertEmbed(vm.range.index, 'video', vm.video, Quill.sources.USER)
      $('#modalVideoPost').modal('hide')

      $timeout(function () {
        vm.video = ''
      }, 1000)
    })
  }

  vm.addSegmentation = function () {
    PostsAdminService.addPostSegmentation($stateParams.id, vm.segmentationId).then(
      function () {
        PostsAdminService.listPostSegmentation($stateParams.id).then(function (result) {
          vm.postSegmentations = generateType(result.results)
        })
      },
      function () {
        swal('This user segmentation already exists', '', 'error')
      },
    )
  }

  vm.deleteSegmentation = function (id) {
    swal(
      {
        title: 'Are you sure?',
        text: 'You really want to delete?',
        type: 'warning',
        showCancelButton: true,
        closeOnConfirm: true,
        closeOnCancel: true,
        animation: 'slide-from-top',
      },
      function (isConfirm) {
        if (isConfirm) {
          PostsAdminService.removePostSegmentation($stateParams.id, id).then(function () {
            PostsAdminService.listPostSegmentation($stateParams.id).then(function (result) {
              vm.postSegmentations = generateType(result.results)
            })
          })
        } else {
          return
        }
      },
    )
  }

  vm.exportCsv = function () {
    CsvService.validSafari()
    var listCsv = []

    PostsAdminService.listPostSegmentationUsers($stateParams.id).then(function (result) {
      var users = result.results

      for (var i = 0; i < users.length; i++) {
        listCsv.push({
          id: users[i].id,
          username: users[i].username === undefined ? '' : users[i].username,
          email: users[i].email,
          name: users[i].name === undefined ? '' : users[i].name,
        })
      }

      var csv = CsvService.convertArrayOfObjectsToCSV({
        data: listCsv,
      })

      if (csv === null) {
        return
      }

      if (CsvService.isSafari() || CsvService.isFirefox()) {
        var link = document.createElement('a')
        link.id = 'csvDwnLink'

        document.body.appendChild(link)
        window.URL = window.URL || window.webkitURL
        var csv2 = '\ufeff' + csv,
          csvData = 'data:attachment/csv;charset=utf-8,' + encodeURIComponent(csv2),
          filename = vm.model.t + '.csv'
        $('#csvDwnLink').attr({ download: filename, href: csvData })
        $('#csvDwnLink')[0].click()
        document.body.removeChild(link)
      } else {
        var filename = vm.model.t + '.csv'

        if (!csv.match(/^data:text\/csv/i)) {
          csv = 'data:text/csv;charset=utf-8,' + csv
        }

        var data = encodeURI(csv)
        var link = document.createElement('a')
        link.setAttribute('href', data)
        link.setAttribute('download', filename)
        link.click()
      }
    })
  }

  function generateType(model) {
    for (var i = 0; i < model.length; i++) {
      if (model[i].k === 1) {
        model[i].type = 'Product'
      } else if (model[i].k === 2) {
        model[i].type = 'Bundle'
      } else if (model[i].k === 3) {
        model[i].type = 'Set'
      }
    }
    return model
  }
}
